import '../../app.es6';
import angular from 'angular';

angular.module('myApp').factory('Page', function () {
  let title = 'マイカルテ';
  return {
    title: function () { return title; },
    setTitle: function (newTitle) { title = newTitle; }
  };
});



// WEBPACK FOOTER //
// ./app/components/title/title.es6